import { TRACK_TYPE_lIST } from '@amwager/util-ts';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getTrackType',
  standalone: true
})
export class GetTrackTypePipe implements PipeTransform {

  transform(trackType: number = -1, runner = false): string {
    if (runner) return TRACK_TYPE_lIST[trackType];

    return trackType === 1
      ? 'Tbred'
      : TRACK_TYPE_lIST[trackType]
  }

}
